export default {
    TRIGGER_CAR_FILTERS: 'trigger-car-filters',
    CLICK_CAR_MARKER: 'cars-marker-click',
    CLEAR_CAR_FILTERS: 'clear-car-filters',
    TRIGGER_MAP_VISIBILITY: 'trigger-map-visibility',
};



// WEBPACK FOOTER //
// ./src/app/modules/cars/config/carEvents.js